import { Box, Container, Stack, Tab, Tabs } from "@mui/material";
import { Helmet } from "react-helmet";
import NewsTopBanner from "./components/NewsTopBanner";
import React from "react";
import PressReleases from "./pressReleases/PressReleases";
import InTheNews from "./inTheNews/InTheNews";
import Articles from "./articles/Articles";
import Announcements from "./announcements/Announcements";
import PageContainer from "shared/components/PageContainer";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 8 }}>{children}</Box>}
    </Box>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const News = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  return (
    <PageContainer>
      <Helmet>
        <title>Radius Care | News Room</title>
      </Helmet>

      <NewsTopBanner></NewsTopBanner>
      <Container maxWidth="md" sx={{ py: 8 }}>
        <Stack
          justifyContent={"center"}
          alignItems="center"
          flexDirection={"row"}
          sx={{
            backgroundColor: "#ffffff",
            borderRadius: { xs: "0", sm: "1rem" },
            boxShadow: 4,
            minHeight: "4.5rem",
            marginX: { xs: "-1rem", sm: "0" },
            "& .MuiTabs-indicator": {
              height: ".25rem",
              background:
                "linear-gradient(90deg, rgba(0,10,109,1) 0%, rgba(224,159,13,1) 100%)",
            },
            "& .MuiTabs-root": {
              minHeight: "4.5rem",
            },
            "& .MuiTabs-flexContainer": {
              height: "100%",
              justifyContent: "center",
            },
            "& .MuiButtonBase-root": {
              fontSize: { xs: ".75rem", sm: "1rem", md: "1.25rem" },
              width: { xs: "25%", md: "12rem" },
              textTransform: "none",
            },
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="Newroom Options"
          >
            <Tab label="Press Releases" {...a11yProps(0)} />
            <Tab label="In the News" {...a11yProps(1)} />
            <Tab label="Articles" {...a11yProps(2)} />
            <Tab label="Announcements" {...a11yProps(3)} />
          </Tabs>
        </Stack>
        <TabPanel value={value} index={0}>
          <PressReleases></PressReleases>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <InTheNews></InTheNews>
        </TabPanel>
        <TabPanel value={value} index={2}>
          <Articles></Articles>
        </TabPanel>
        <TabPanel value={value} index={3}>
          <Announcements></Announcements>
        </TabPanel>
      </Container>

      
    </PageContainer>
  );
};

export default News;
